import React from "react";
import { Tooltip } from "@mui/material";
import { needsMessage, useCan } from "../modules/settings/accessRoles";

// Disables its one child control when the user doesn't have the role for it,
// and says which role is needed on hover. Without a role, the control still shows.
export default function Gate({ capability, children }) {
  const can = useCan();
  if (can(capability)) return children;
  return (
    <Tooltip title={needsMessage(capability)} arrow>
      <span style={{ display: "inline-flex" }}>{React.cloneElement(React.Children.only(children), { disabled: true })}</span>
    </Tooltip>
  );
}
